import React, { useLayoutEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { COLORS } from '../settings/variables/Colors';

interface TrueImpactReadmoreProps {
  text: string;
  lines?: number;
  className?: string;
}

const StyledDiv = styled.div``;

const TextBlock = styled.div<{ lines: number; expanded: boolean }>`
  line-height: 1.6;
  word-break: break-word;
  ${({ expanded, lines }) =>
    expanded
      ? ''
      : `
    display: -webkit-box;
    -webkit-line-clamp: ${lines};
    -webkit-box-orient: vertical;
    overflow: hidden;
  `}
`;

const Toggle = styled.span`
  display: inline;
  cursor: pointer;
  color: ${COLORS.ctaPrimary};
  font-size: inherit;
  font-weight: 500;
  white-space: nowrap;
  &:hover {
    text-decoration: underline;
  }
`;

const TrueImpactReadmore: React.FC<TrueImpactReadmoreProps> = ({
  text,
  lines = 3,
  className,
}) => {
  const [expanded, setExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    setIsTruncated(el.scrollHeight > el.clientHeight + 1);
  }, [text, lines]);

  return (
    <StyledDiv className={className}>
      <TextBlock ref={ref} lines={lines} expanded={expanded}>
        {text}
        {expanded && isTruncated && (
          <>
            {' '}
            <Toggle onClick={() => setExpanded(false)}>Show less</Toggle>
          </>
        )}
      </TextBlock>
      {!expanded && isTruncated && (
        <Toggle onClick={() => setExpanded(true)}>Read more</Toggle>
      )}
    </StyledDiv>
  );
};

export default TrueImpactReadmore;
